import _assign from "object-assign";
import warning from 'warning';
import { ANNOUNCEMENT_EVENT_NAME, ARIA_ANNOUNCER_ID } from './constants';

var emit = function emit(_ref) {
  var elem = _ref.elem,
      name = _ref.eventName,
      detail = _ref.detail;
  var value = {
    value: undefined
  };
  var opts = {
    bubbles: true,
    cancelable: true,
    composed: false,
    detail: _assign({}, value, detail)
  };
  var evt = createCustomEvent(name, opts);
  return elem.dispatchEvent(evt);
};

export var dispatchAnnouncementEvent = function dispatchAnnouncementEvent(announcementText, delay) {
  var announcerElement = typeof document !== 'undefined' && document.getElementById(ARIA_ANNOUNCER_ID);

  if (announcerElement) {
    emit({
      elem: announcerElement,
      eventName: ANNOUNCEMENT_EVENT_NAME,
      detail: {
        announcement: announcementText,
        delay: delay
      }
    });
  } else {
    warning(false, 'dispatchAnnouncementEvent is being invoked when an aria-announcer has not been installed. Your application should include an aria-announcer');
  }
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

var createCustomEvent = function createCustomEvent(name, opts) {
  if ('composed' in CustomEvent.prototype) {
    return new CustomEvent(name, opts);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, opts.bubbles, opts.cancelable, opts.detail);
    Object.defineProperty(evt, 'composed', {
      value: opts.composed
    });
    return evt;
  }
};